import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';

class PriceDialog extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      product: '',
      price: '',
      savedSnackbar: false,
      priceError: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  closeSnackbar = () => {this.setState({savedSnackbar: false});}

  handlePriceChange = (event, price) => this.setState({price: price.trim().replace(',','.'), priceError: ''})

  validatePrice = () => {
    const price = this.state.price;
    const {t} = this.props;

    if (!price) {
      this.setState({priceError: t('product.priceRequired')});
      return false;
    } else if (isNaN(price)) {
      this.setState({priceError: t('product.priceNotNumber')});
      return false;
    } else if (parseFloat(price) < 0)  {
      this.setState({priceError: t('product.priceLessThanZero')});
      return false;
    } else if (parseFloat(parseFloat(price).toFixed(2)) !== parseFloat(price)) {
      this.setState({priceError: t('product.tooManyDecimals')});
      return false;
    }

    return true;
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.product) {
      this.setState({product: nextProps.product, price: nextProps.product.price});
    }
  }
  handleSave = () => {
    if(!this.validatePrice) return;

    const {firebase, user} = this.props;

    let price = this.state.price;
    firebase.database()
      .ref(`shopkeepers/${user.shopkeeperId}/stands/${this.props.standKey}/products/${this.state.product.key}`)
      .update({price})
      .then(() => {
        this.setState({ ...this.initialState, savedSnackbar: true});
        this.props.handleClose(price);
      });
  }
  handleClose = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }
  handlePriceChange = (event, price) => this.setState({price: price.trim().replace(',','.'), priceError: ''})

  render()  {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('save')}
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    const contentStyle = (this.props.eventPosition)
      ? {
        position: 'absolute',
        maxWidth: '310px',
        top: this.props.eventPosition.y,
        left: this.props.eventPosition.x
      }
      : {
        maxWidth: '300px'
      };

    const title = (this.props.standName)
      ? t('stand.editPrice') + ' - ' + this.props.standName
      : t('stand.editPrice') + ' - ' + this.state.product.name;

    const snackbar = (this.props.standName)
      ? t('stand.priceSaved') + ' - ' + this.props.standName
      : t('stand.priceSaved') + ' - ' + this.state.product.name;

    return (
      <div>
        <Dialog title={title}
          titleStyle={{maxHeight: '40px', overflow: 'hidden'}}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
          contentStyle={contentStyle}>
          <TextField
            hintText={t('product.price')}
            floatingLabelText={t('product.price')}
            style={{width: 150}}
            inputStyle={{textAlign: 'right'}}
            onChange={this.handlePriceChange}
            value={this.state.price}
            onBlur={this.validatePrice}
            errorText={this.state.priceError}
          />
        </Dialog>
        <Snackbar
          open={this.state.savedSnackbar}
          message={snackbar}
          autoHideDuration={4000}
          onRequestClose={this.closeSnackbar}
        />
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(PriceDialog);



// WEBPACK FOOTER //
// ./src/Stand/PriceDialog.js